// extracted by mini-css-extract-plugin
module.exports = {"xt-scroll-div":"index_xt-scroll-div__zjEAO","xtScrollDiv":"index_xt-scroll-div__zjEAO"};